import { Carousel } from 'primereact'
import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

const CarouselScreen = () => {

    let {id} = useParams();



    const [value, setValue] = useState([])

    const Item = (a) => {
        // console.log(a);
        return <div  style={{ width: '100%', display:'flex', justifyContent: 'center', margin: 0 }}>
            <img  src={a.link} alt="" style={{ height: '100vh',margin: 'auto', width: '90vw' }} />
        </div>
    }

    // const value = 

    useEffect(() => {
        let val = [
            // {
            //     link: 'https://were.ppf.com.hn/assets/Campionato.png'
            // },
            // {
            //     link: 'https://were.ppf.com.hn/Comunicados/PPF23-RH000014.png'
            // },
        ];
            for (let i = 1; i <= 37; i++) {
                val.push({
                    link: `https://were.ppf.com.hn/Comunicados/Navidad23/Slide${i.toString()}.jpeg`
                })
            }
        console.log(val);

        setValue(val)


        // setInterval(() => {
        //     let url = window.location.href;
        //     window.location.href = url;
        // }, 1000 * 30 * 60);
        
    }, [])

  return (
    <div style={{ background: '#FFFFFF' }}>
        <Carousel value={value} numVisible={1} numScroll={1}  circular 
        autoplayInterval={1000 * 15}
        itemTemplate={Item} style={{ height: '100vh', width: '100vw' }}/>
    </div>
  )
}

export default CarouselScreen